// Shared client-side email validation, mirroring
// netlify/functions/_lib/emailValidation.js so users get the same rejection
// before the network round-trip that the server would enforce anyway.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// RFC 2606 reserved example domains plus the generic "test.com" placeholder
// people commonly type into forms by mistake.
const DENIED_EMAIL_DOMAINS = new Set([
  "example.com",
  "example.net",
  "example.org",
  "test.com"
]);

export function isValidEmail(value) {
  const email = String(value || "").trim().toLowerCase();
  if (!EMAIL_RE.test(email)) return false;
  const domain = email.split("@")[1] || "";
  return !DENIED_EMAIL_DOMAINS.has(domain);
}

export const INVALID_EMAIL_MESSAGE = "Please enter a valid email address.";
